function createFormStore() {

    const forms = []

    function matches(key, query) {
        if (!key || !query) {
            return false
        }
        return Object.keys(query).every((k) => String(key[k]) === String(query[k]))
    }

    function find(query) {
        const entry = forms.find((f) => matches(f.key, query))
        return entry ? entry.api : null
    }

    return {

        register(key, api) {
            const entry = { key: key || {}, api: api || {} }
            forms.push(entry)
            return entry
        },

        unregister(token) {
            const i = forms.indexOf(token)
            if (i > -1) {
                forms.splice(i, 1)
            }
        },

        get(query) {
            return find(query)
        },

        has(query) {
            return !!find(query)
        },

        setValue({ field, value, ...query } = {}) {
            const api = find(query)
            if (api && typeof api.setField === 'function') {
                return api.setField(field, value)
            }
            return false
        },

        setValues({ values, ...query } = {}) {
            const api = find(query)
            if (api && typeof api.setFields === 'function') {
                return api.setFields(values || {})
            }
            return false
        },

        getValues(query = {}) {
            const api = find(query)
            return (api && typeof api.getValues === 'function') ? api.getValues() : null
        }
    }
}

const formStore = createFormStore()

export default formStore
